import React from 'react';
import { Link } from "react-scroll";
import Button from 'react-bootstrap/Button';

// import { Container } from './styles';

function Extraordinario({patter3, extraordinario1, newAttendance, arrowUp, arrowDown}) {
    return (
        <div  id="extraordinario">
            <div className="bodySolucoes sumir" style={{backgroundColor: 'var(--main-white-color)', width: "100%", marginBottom: 50, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <img
                    src={patter3}
                    alt="patter3"
                    className='patter3'
                />
                <div
                style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 120,
                    lineHeight: 1,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br>
                        RESÍDUO EXTRAORDINÁRIO
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6' 
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: 20,
                        position: 'relative',
                    }}>
                        <Link
                            activeClass="active"
                            to="solucoes"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="biologico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                            src={extraordinario1}
                            alt="Imagem Residuo Extraordinario"
                            style={{width: "90%", paddingLeft: 68}}
                        />
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        flexDirection: 'column'
                    }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingRight: 120
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText'>
                                Com mais de 19 anos no mercado, o Grupo Urbam é especializado em coleta de resíduos extraordinário, possuindo todas as licenças legais para coletas e destinação final, conforme lei nº12.305, de 2 de agosto de 2010. <br></br><br></br>
                                Com uma frota com mais de 100 veículos, garantimos disponibilidade logística para melhor atender a sua necessidade. <br></br><br></br>
                                Os Resíduos Extraordinários fazem parte do grupo D ou classe IIA ou classe IIB e são aqueles tipos de materiais classificados como lixo comum.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Extraordinário')}
                                >
                                    ORÇAMENTO | RESÍDUO EXTRAORDINÁRIO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bodySolucoes mostrar" style={{backgroundColor: 'var(--main-white-color)', width: "100%", margin: 0, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <div
                style={{
                    display: "flex",
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    lineHeight: 1,
                    height: 160,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br> 
                        RESÍDUO EXTRAORDINÁRIO <br></br>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <Link
                            activeClass="active"
                            to="solucoes"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="biologico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                        src={extraordinario1}
                        alt="Imagem Residuo Extraordinario"
                        style={{width: "94%", paddingLeft: 68}}
                        />
                        
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 60 
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                                Com mais de 19 anos no mercado, o Grupo Urbam é especializado em coleta de resíduos extraordinário, possuindo todas as licenças legais para coletas e destinação final, conforme lei nº12.305, de 2 de agosto de 2010. <br></br><br></br>
                                Com uma frota com mais de 100 veículos, garantimos disponibilidade logística para melhor atender a sua necessidade. <br></br><br></br>
                                Os Resíduos Extraordinários fazem parte do grupo D ou classe IIA ou classe IIB e são aqueles tipos de materiais classificados como lixo comum.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Extraordinário')}
                                >
                                    RESÍDUO EXTRAORDINÁRIO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Extraordinario;